/**
 * @generated SignedSource<<7292e17847158333598e325baf32d2dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReportingUserActivityEntity = "Assignment" | "AssignmentSubmission" | "Bookmark" | "ChatChannel" | "Content" | "ContentUsage" | "ContinueYourProductsDashboardBlock" | "CurriculumItem" | "CurriculumSection" | "Lesson" | "Organization" | "Poll" | "Post" | "Quiz" | "RecentlyViewedDashboardBlock" | "Survey" | "Task" | "%future added value";
export type ReportingUserActivityKind = "attended" | "bookmark_click" | "channel_message_reaction" | "channel_message_sent" | "clicked" | "commented" | "completed" | "created" | "direct_message_reaction" | "direct_message_sent" | "reaction" | "search" | "search_hit" | "%future added value";
export type AdminMembersReportDailyDiscussionsChartQuery$variables = {
  entities?: ReadonlyArray<ReportingUserActivityEntity> | null;
  id: string;
  kinds?: ReadonlyArray<ReportingUserActivityKind> | null;
  startDate?: string | null;
};
export type AdminMembersReportDailyDiscussionsChartQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly __typename: "OrganizationMembership";
    readonly dailyUserActivityReport: {
      readonly data: ReadonlyArray<{
        readonly date: string;
        readonly totalActivity: number;
      }> | null;
    };
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportDailyDiscussionsChartQuery = {
  response: AdminMembersReportDailyDiscussionsChartQuery$data;
  variables: AdminMembersReportDailyDiscussionsChartQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kinds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "entities",
      "variableName": "entities"
    },
    {
      "kind": "Variable",
      "name": "kinds",
      "variableName": "kinds"
    },
    {
      "kind": "Variable",
      "name": "startDate",
      "variableName": "startDate"
    }
  ],
  "concreteType": "OrganizationMembershipReportingDailyUserActivityReportResponse",
  "kind": "LinkedField",
  "name": "dailyUserActivityReport",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DailyUserActivity",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalActivity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportDailyDiscussionsChartQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportDailyDiscussionsChartQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "903ba9acaabac6d7c592215457f40280",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportDailyDiscussionsChartQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportDailyDiscussionsChartQuery(\n  $id: ID!\n  $startDate: String\n  $kinds: [ReportingUserActivityKind!]\n  $entities: [ReportingUserActivityEntity!]\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      __typename\n      dailyUserActivityReport(startDate: $startDate, kinds: $kinds, entities: $entities) {\n        data {\n          date\n          totalActivity\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f607a235ce7f883c3b9ac65b69b9327";

export default node;
